import { SubscriptionFrequency } from "common/types";
import { stringToFrequencyValue, frequencyValueToString } from "common/utils/subscriptions";
import { dedupeByKey } from "common/utils/entities";

import Select from "client/common/components/inputs/Select";
import ModalLayout from "client/common/components/deprecated-modals/ModalLayout";

import { ClientSubscription, ListSubscription, OnboardingDetailSubscription } from "../types";

type SubscriptionFrequencySelectProps = {
  subscription: ClientSubscription | ListSubscription | OnboardingDetailSubscription;
  onSelect: (params: SubscriptionFrequency) => void;
  value: SubscriptionFrequency;
  activeDisplay?: string;
};

const SubscriptionFrequencySelect = ({
  subscription,
  onSelect,
  value,
  activeDisplay = "active",
}: SubscriptionFrequencySelectProps) => {
  const onChange = (val: string) => {
    onSelect(stringToFrequencyValue(val));
  };

  const optionsWithKeys = dedupeByKey(
    [
      ...(value ? [value] : []),
      ...(subscription.is_active_frequency_valid ? [subscription.active_frequency] : []),
      subscription.recommended_frequency,
      ...subscription.alternative_frequencies,
    ].map((option) => ({
      option,
      key: frequencyValueToString(option),
    })),
    "key",
    "last",
  );

  const recommendedOptionKey = subscription.recommended_frequency
    ? frequencyValueToString(subscription.recommended_frequency)
    : "";

  const activeOptionKey = subscription.active_frequency
    ? frequencyValueToString(subscription.active_frequency)
    : "";

  const suffix = (key: string) => {
    if (key === activeOptionKey) {
      return ` (${activeDisplay})`;
    }
    return key === recommendedOptionKey ? " (recommended)" : "";
  };

  return (
    <div>
      <ModalLayout.Form.Group>
        <Select label="Select frequency" onChange={onChange} value={frequencyValueToString(value)}>
          {optionsWithKeys.map(({ option, key }) => (
            <Select.Option key={key} value={key}>
              {`${option.display}${suffix(key)}`}
            </Select.Option>
          ))}
        </Select>
      </ModalLayout.Form.Group>
    </div>
  );
};

export default Object.assign(SubscriptionFrequencySelect, {
  frequencyValueToString,
  stringToFrequencyValue,
});
